import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import { handleError, handleSuccess } from "../../Common/Layout/CustomAlerts";
export default function ChangeSubscription() {
    const params = useParams();
    const navigate = useNavigate();
    const [client, setClient] = useState({});
    const [lists, setLists] = useState([]);
    const [loadingStates, setLoadingStates] = useState({});
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    const handleSubmit = (e, data, amount, cycle) => {
        e.preventDefault();
        setLoadingStates(prev => ({ ...prev, [data.subscriptionId]: true }));
        var creditstotal = 0;
        var interval = "month";
        var intervalCount = 1;
        var startDate = new Date();
        var endDate = new Date();
        var renewalDate = new Date();

        if (client != null) {
            startDate = new Date(client.endDate);
            startDate.setDate(startDate.getDate() + 1);
            endDate.setDate(startDate.getDate());
            renewalDate.setDate(startDate.getDate());
            creditstotal = parseInt(data.credits) * 1;
        }

        if (cycle === "MONTH") {
            endDate.setMonth(startDate.getMonth() + 1);
            renewalDate = new Date(endDate);
            renewalDate.setDate(renewalDate.getDate() + 1);
            creditstotal = parseInt(data.credits) * 1;
        }
        if (cycle === "SIX") {
            endDate.setMonth(startDate.getMonth() + 6);
            renewalDate = new Date(endDate);
            renewalDate.setDate(renewalDate.getDate() + 1);
            intervalCount = 6;
            creditstotal = parseInt(data.credits) * 6;
        }
        if (cycle === "YEAR") {
            endDate.setMonth(startDate.getMonth() + 12);
            renewalDate = new Date(endDate);
            renewalDate.setDate(renewalDate.getDate() + 1);
            interval = "year";
            creditstotal = parseInt(data.credits) * 12;
        }

        var formData = {
            "clientRenewalId": client.clientRenewalId,
            "clientId": params.clientId,
            "userId": client.userId,
            "type": client.type,
            "referenceId": data.subscriptionId,
            "startDate": moment(startDate).format('YYYY-MM-DD'),
            "endDate": moment(endDate).format('YYYY-MM-DD'),
            "renewalDate": moment(renewalDate).format('YYYY-MM-DD'),
            "createdDate": moment(new Date()).format('YYYY-MM-DD'),
            "updatedDate": moment(new Date()).format('YYYY-MM-DD'),
            "amount": parseInt(amount),
            "paymentMethodId": client.paymentMethodId,
            "interval": interval,
            "intervalCount": intervalCount,
            "credits": parseInt(creditstotal),
            "isActive": client.IsActive,
            "stripeSubscriptionId": client.stripeSubscriptionId,
            "priceId": client.priceId,
            "credits": client.creditstotal
        }
        ChangeSubscriptionData(formData)
    };
    const ChangeSubscriptionData = (newdata) => {
        axios.post(config.APIACTIVATEURL + config.CHANGESUBSCRIPTION, newdata, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLoadingStates({});
                    GetClient();
                    handleSuccess("Subscription Successfully updated");
                }
                else {
                    setLoadingStates(prev => ({ ...prev, [newdata.subscriptionId]: false }));
                    handleError("Error in subscription");
                }
                setLoadingStates(false);
            })
            .catch(() => {
                setLoadingStates(prev => ({ ...prev, [newdata.subscriptionId]: false }));
                setLoadingStates(false);
            });
    };
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETSUBSCRIPTIONS + "?pageNumber=1&pageSize=20", { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLists(response.data.data.data);
                }
            });
    };
    const GetClient = () => {
        axios.get(config.APIACTIVATEURL + config.GETCLIENTPLANS + "?ClientId=" + params.clientId, { ...headerconfig })
            .then((response) => {
                console.log(response.data.data.data[0]);
                if (response.data.statusCode === 200) {
                    if (response.data.data.data !== null) {
                        setClient(response.data.data.data[0]);
                        GetData();
                    }
                }
            });
    };
    useEffect(() => {
        if (params == null) {
            navigate("/");
        }
        else {
            GetClient();
        }
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <>
                        <div className="row justify-content-center">
                            <div className="card">
                                <div className="row justify-content-center mt-3">
                                    <div className="col-lg-5">
                                        <div className="text-center pb-2">
                                            <h4 className="fw-semibold fs-6">Choose the plan that's right for you</h4>
                                            <p className="text-muted mb-4 fs-4">Simple pricing. No hidden fees.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card align-items-center justify-content-between">
                                <ul className="nav nav-pills arrow-navtabs nav-success mb-3 mt-2" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" data-bs-toggle="tab" href="#arrow-month" role="tab">
                                            <span className="d-none d-sm-block">Monthly</span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#arrow-six" role="tab">
                                            <span className="d-none d-sm-block">6 Months <span className="badge bg-success">10% Off</span></span>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" data-bs-toggle="tab" href="#arrow-year" role="tab">
                                            <span className="d-none d-sm-block">Annual <span className="badge bg-success">20% Off</span></span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="tab-content text-black">
                            {/* Monthly Plans */}
                            <div className="tab-pane active" id="arrow-month" role="tabpanel">
                                <div className="row">
                                    {lists.filter(li => li.type !== "TRAIL").map((li) => (
                                        <div className="col-4" key={li.subscriptionId}>
                                            <div className="card plan-cards border rounded-3 p-4 d-flex flex-column gap-7">
                                                <div className="flex-grow-1">
                                                    <h3 className="fs-6 fw-semibold mb-3">{li.subscriptionName}</h3>
                                                    <p>
                                                        <h3 className="fs-3 fw-normal mb-0 text-muted">
                                                            <span className="fs-10 fw-bolder text-primary">${li.fee}</span>/ monthly
                                                        </h3>
                                                    </p>
                                                </div>
                                                <ul className="list-unstyled vstack gap-3 mb-0 mt-2">
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">MCA Processing</b>: Includes <b>{li.credits} Credits per month</b></li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Data Entry</b>: App and Bank Statements, and Broker Sync 360 auto-matches to funders</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Funders Matching</b>: Fully automated funder matching & submission</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Funder Matrix</b> : Access to <b>{li.fundersAccess}</b> funders</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Users Included</b> : <b>{li.totalUsers} Seat</b></li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Unused Purchased Credits Roll Over</b> to future months</li>
                                                </ul>
                                                <div className="mt-4">
                                                    {client.subscriptionId === li.subscriptionId && client.interval === "month" ?
                                                        <button className="btn btn-success w-100 waves-effect waves-light" disabled>CURRENT PLAN (Ends on {moment(client.endDate).format("DD MMM YYYY")})</button>
                                                        :
                                                        <button
                                                            className="btn btn-success w-100 waves-effect waves-light"
                                                            onClick={(e) => handleSubmit(e, li, li.fee, "MONTH")}
                                                            disabled={loadingStates[li.subscriptionId]}
                                                        >
                                                            {loadingStates[li.subscriptionId] ? "Processing..." : "SELECT PLAN"}
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* 6 Month Plans */}
                            <div className="tab-pane" id="arrow-six" role="tabpanel">
                                <div className="row">
                                    {lists.filter(li => li.type !== "TRAIL").map((li) => (
                                        <div className="col-4" key={li.subscriptionId}>
                                            <div className="card plan-cards border rounded-3 p-4 d-flex flex-column gap-7">
                                                <div className="flex-grow-1">
                                                    <h3 className="fs-6 fw-semibold mb-3">{li.subscriptionName}</h3>
                                                    <p><span className="fs-9 fw-bolder text-primary">${li.sixMonthsFee}</span>/ 6months</p>
                                                </div>
                                                <ul className="list-unstyled vstack gap-3 mb-0 mt-2">
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">MCA Processing</b>: Includes <b>{li.credits} Credits per month</b></li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Data Entry</b>: App and Bank Statements, and Broker Sync 360 auto-matches to funders</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Funders Matching</b>: Fully automated funder matching & submission</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Funder Matrix</b> : Access to <b>{li.fundersAccess}</b> funders</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Users Included</b> : <b>{li.totalUsers} Seat</b></li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Unused Purchased Credits Roll Over</b> to future months</li>
                                                </ul>
                                                <div className="mt-4">
                                                    {client.subscriptionId === li.subscriptionId && client.interval === "six" ?
                                                        <button className="btn btn-success w-100 waves-effect waves-light" disabled>CURRENT PLAN (Ends on {moment(client.endDate).format("DD MMM YYYY")})</button>
                                                        :
                                                        <button
                                                            className="btn btn-success w-100 waves-effect waves-light"
                                                            onClick={(e) => handleSubmit(e, li, li.sixMonthsFee, "SIX")}
                                                            disabled={loadingStates[li.subscriptionId]}
                                                        >
                                                            {loadingStates[li.subscriptionId] ? "Processing..." : "SELECT PLAN"}
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Annual Plans */}
                            <div className="tab-pane" id="arrow-year" role="tabpanel">
                                <div className="row">
                                    {lists.filter(li => li.type !== "TRAIL").map((li) => (
                                        <div className="col-4" key={li.subscriptionId}>
                                            <div className="card plan-cards border rounded-3 p-4 d-flex flex-column gap-7">
                                                <div className="flex-grow-1">
                                                    <h3 className="fs-6 fw-semibold mb-3">{li.subscriptionName}</h3>
                                                    <p><span className="fs-9 fw-bolder text-primary mt-2">${li.tweleveMonthsFee}</span>/ yearly</p>
                                                </div>
                                                <ul className="list-unstyled vstack gap-3 mb-0">
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Price</b> : ${li.tweleveMonthsFee}/month</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">MCA Processing</b>: Includes <b>{li.credits} Credits per month</b></li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Data Entry</b>: App and Bank Statements, and Broker Sync 360 auto-matches to funders</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Funders Matching</b>: Fully automated funder matching & submission</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Funder Matrix</b> : Access to <b>{li.fundersAccess}</b> funders</li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Users Included</b> : <b>{li.totalUsers} Seat</b></li>
                                                    <li><i className="ri-checkbox-circle-fill fs-2 align-middle text-success mr-2"></i><b className="me-2">Unused Purchased Credits Roll Over</b> to future months</li>
                                                </ul>
                                                <div className="mt-4">
                                                    {client.subscriptionId === li.subscriptionId && client.interval === "year" ?
                                                        <button className="btn btn-success w-100 waves-effect waves-light" disabled>CURRENT PLAN (Ends on {moment(client.endDate).format("DD MMM YYYY")})</button>
                                                        :
                                                        <button
                                                            className="btn btn-success w-100 waves-effect waves-light"
                                                            onClick={(e) => handleSubmit(e, li, li.tweleveMonthsFee, "YEAR")}
                                                            disabled={loadingStates[li.subscriptionId]}
                                                        >
                                                            {loadingStates[li.subscriptionId] ? "Processing..." : "SELECT PLAN"}
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </div>
    );
}